import { DashboardActions } from '../types/DashboardAction';
import { UserBody } from '../types/UsersBody';

interface DashboardState {
    reviewees: UserBody[],
    hasMyLibraryQueue: boolean,
};

const initialState: DashboardState = {
    reviewees: [],
    hasMyLibraryQueue: false,
};


const dashboardReducers = (state = initialState, action: DashboardActions) => {
    switch (action.type) {
        case 'REVIEWEES': {
            return { ...state, reviewees: action.data }
        }
        case 'HAS_MY_LIBRARY_QUEUE': {
            return { ...state, hasMyLibraryQueue: action.data }
        }
        default:
            return state;
    }
}

export default dashboardReducers;